(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('stringFilterValue', stringFilterValue);

    function stringFilterValue() {
        return {
            restrict: 'EA',
            scope: {
                filterValueModel: '='
            },
            controller: stringFilterValueCtrl,
            controllerAs: 'vm',
            bindToController:true,
            templateUrl: 'common/components/filter-values-type/string'
        };
    }

    function stringFilterValueCtrl() {

    }
})();